import { useQuery } from '@tanstack/react-query';
import { getCameras } from './getCameras';

/**
 * React Query hook for fetching camera taxonomy.
 * Caches data for 5 minutes and retries failed requests twice.
 */
export const useCameras = () => {
  return useQuery({
    queryKey: ['cameras'],
    queryFn: getCameras,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};

